import { Controller } from "@hotwired/stimulus"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// Il caricamento del decreto (Decreto.js, 31a5bd1).
// - «Carica il decreto (PDF)» apre la scelta del file; la scelta invia subito (onChange → invia). Nessun file: nessun invio.
// - disabled={busy || (!grant && !nomeBando.trim())}: serve un bando scelto o un nome scritto; «Nome del bando» c'è solo
//   senza bando scelto (nascosto, ma il suo testo resta nel form: l'originale lo inviava comunque).
// - durante l'invio la rotella (Loader2) al posto dell'icona e il pulsante disattivato; alla fine, riuscito o no, l'input
//   torna vuoto (finally). Bando, nome e tipo restano come scelti.
// - Una visita Turbo fermerebbe l'invio del form (navigator.stop): finché la risposta non arriva le visite si fermano
//   (lib/visite_trattenute.js) e l'ultima riparte a fine invio. Un secondo invio durante il primo è ignorato.
// - Una risposta d'errore che non è un Turbo Stream (500, pagina del proxy) non diventa la pagina; dà un toast.
const STREAM = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["bando", "nome", "file", "pulsante", "icona", "rotella"]

  connect() {
    this.visite = new VisiteTrattenute()
    this.inVolo = false
    this.aggiorna()
  }

  disconnect() {
    this.visite.rilascia()
  }

  aggiorna() {
    const scelto = this.bandoTarget.value !== ""
    this.nomeTarget.hidden = scelto
    this.pulsanteTarget.disabled = this.inVolo || (!scelto && this.nomeTarget.value.trim() === "")
  }

  scegli() {
    this.fileTarget.click()
  }

  scelto() {
    if (!this.inVolo && this.fileTarget.files?.length) this.element.requestSubmit()
  }

  inizio(event) {
    if (event.target !== this.element) return
    this.inVolo = true
    this.visite.trattieni()
    this.attesa(true)
  }

  risposta(event) {
    if (event.target !== this.element) return
    this.visite.lascia()
    const r = event.detail.fetchResponse
    if (r && !r.succeeded && !(r.contentType || "").startsWith(STREAM)) event.preventDefault()
  }

  fine(event) {
    if (event.target !== this.element) return
    const url = this.visite.rilascia()
    this.inVolo = false
    this.attesa(false)
    this.fileTarget.value = ""
    const { success, fetchResponse } = event.detail
    if (!success && !(fetchResponse?.contentType || "").startsWith(STREAM)) window.toast?.error?.("Caricamento non riuscito")
    if (url) riparti(url)
  }

  attesa(si) {
    this.rotellaTarget.classList.toggle("hidden", !si)
    this.iconaTarget.classList.toggle("hidden", si)
    this.aggiorna()
  }
}
